/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} North_Slimy_Butterfly_PickInputs */

const fr_north_slimy_butterfly_pick = /** @type {(inputs: North_Slimy_Butterfly_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min (min:sec)`)
};

/**

* @param {North_Slimy_Butterfly_PickInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const north_slimy_butterfly_pick = /** @type {((inputs?: North_Slimy_Butterfly_PickInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<North_Slimy_Butterfly_PickInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_north_slimy_butterfly_pick(inputs)
});